import { render } from "./Banner.component.vue?vue&type=template&id=74433f89&ts=true"
import script from "./Banner.component.vue?vue&type=script&lang=ts"
export * from "./Banner.component.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__